import { hexToRgba, hslToRgb, rgbaToHex, rgbToHsl } from 'tools/colorHelpers';

// The light theme's color for a dark background. The very light colors are backgrounds there and
// go dark, the very dark ones are text and lines and go light; those in between keep their place,
// brought towards the middle so they neither vanish nor glare. The transparency stays.
export function getDarkColor(light: string): string {
	if (!light?.startsWith('#')) {
		return light;
	}

	const { r, g, b, a } = hexToRgba(light);
	const { h, s, l } = rgbToHsl({ r, g, b });
	const dark = hslToRgb({ h, s: s * 0.85, l: getDarkLightness(l) });

	return rgbaToHex(dark.r, dark.g, dark.b, a < 1 ? a : undefined);
}

// only the nearly white and the nearly black ones turn over: a pastel stays a pastel
function getDarkLightness(l: number) {
	if (l >= 88) {
		return 8 + (100 - l) * 1.2;
	}

	if (l <= 20) {
		return 92 - l * 0.7;
	}

	return Math.min(75, Math.max(45, l + 5));
}
